<style scoped>
.two-part {
  width: 50%;
  padding: 10px;
}
.form-group:not([class*=' col-']) {
  width: 100%;
  width: 33.333333%;
  padding-left: 5px;
  padding-right: 5px;
  padding-top: -5px;
  padding-bottom: -5px;
}
.fixHeightScrollable {
  overflow: auto;
  height: 700px;
}
</style>

<template>
  <div>
    <b-form
      class="needs-validation"
      novalidate
      @submit="onSubmit"
      @reset="onReset"
    >
      <div class="d-flex justify-content-between">
        <h5></h5>
        <div>
          <b-button-group v-if="editableOps">
            <b-button type="submit" variant="outline-primary" size="sm"
              ><span v-if="form.intId === undefined">Save</span><span v-else>Update</span></b-button
            >
            <b-button type="reset" variant="outline-danger" size="sm"
              >Reset</b-button
            >
          </b-button-group>
        </div>
      </div>
    </b-form>
    <br />
    <div class="overflow-auto">
      <div>
        <hr />
        <div class="fixHeightScrollable">
          <h5 align="center">General</h5>
          <hr />
          <h6>JOB</h6>
          <hr />
          <b-form-group
            id="input-group-jobType"
            label="Job Type:"
            label-for="input-jobType"
          >
            <b-form-select
              id="input-jobType"
              v-model="form.jobType"
              type="text"
              placeholder="Enter Job Type"
              :options="optionsComboJobType"
              :required="true"
              :disabled="!editable"
            ></b-form-select>
          </b-form-group>
          <b-form-group
            id="input-group-contractor"
            label="Contractor:"
            label-for="input-contractor"
          >
            <b-form-input
              id="input-contractor"
              v-model="form.contractor"
              type="text"
              placeholder="Enter Contractor"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-foreman"
            label="Foreman:"
            label-for="input-foreman"
          >
            <b-form-input
              id="input-foreman"
              v-model="form.foreman"
              type="text"
              placeholder="Enter Foreman"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-arrivalDateTime"
            label="Arrival Date Time:"
            label-for="input-arrivalDateTime"
          >
            <b-form-input
              id="input-arrivalDateTime"
              v-model="form.arrivalDateTime"
              type="datetime-local"
              placeholder="Enter Arrival Date Time"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-cementJobStartDateTime"
            label="Cement Job Start Date Time:"
            label-for="input-cementJobStartDateTime"
          >
            <b-form-input
              id="input-cementJobStartDateTime"
              v-model="form.cementJobStartDateTime"
              type="datetime-local"
              placeholder="Enter Cement Job Start Date Time"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-jobEndDateTime"
            label="Job End Date Time:"
            label-for="input-jobEndDateTime"
          >
            <b-form-input
              id="input-jobEndDateTime"
              v-model="form.jobEndDateTime"
              type="datetime-local"
              placeholder="Enter Job End Date Time"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-geothermalGradient"
            label="Geothermal Gradient:"
            label-for="input-geothermalGradient"
          >
            <b-form-input
              id="input-geothermalGradient"
              v-model="form.geothermalGradient"
              type="number"
              step="0.001"
              placeholder="Enter Geothermal Gradient"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-wocTimeGeneral"
            label="WOC Time General:"
            label-for="input-wocTimeGeneral"
          >
            <b-form-input
              id="input-wocTimeGeneral"
              v-model="form.wocTimeGeneral"
              type="number"
              step="0.001"
              placeholder="Enter WOC Time General"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-groundTemp"
            label="Ground Temp:"
            label-for="input-groundTemp"
          >
            <b-form-input
              id="input-groundTemp"
              v-model="form.groundTemp"
              type="number"
              step="0.001"
              placeholder="Enter Ground Temp"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-airTemp"
            label="Air Temp:"
            label-for="input-airTemp"
          >
            <b-form-input
              id="input-airTemp"
              v-model="form.airTemp"
              type="number"
              step="0.001"
              placeholder="Enter Air Temp"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-seabedTemp"
            label="Seabed Temp:"
            label-for="input-seabedTemp"
          >
            <b-form-input
              id="input-seabedTemp"
              v-model="form.seabedTemp"
              type="number"
              step="0.001"
              placeholder="Enter Seabed Temp"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-annulusTemp"
            label="Annulus Temp:"
            label-for="input-annulusTemp"
          >
            <b-form-input
              id="input-annulusTemp"
              v-model="form.annulusTemp"
              type="number"
              step="0.001"
              placeholder="Enter Annulus Temp"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-bht"
            label="BHT:"
            label-for="input-bht"
          >
            <b-form-input
              id="input-bht"
              v-model="form.bht"
              type="number"
              step="0.001"
              placeholder="Enter BHT"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-c02"
            label="C02:"
            label-for="input-c02"
          >
            <b-form-checkbox
              id="input-c02"
              v-model="form.c02"
              type="number"
              :value="1"
              :unchecked-value="0"
              placeholder="Enter C02"
              :disabled="!editable"
            ></b-form-checkbox>
          </b-form-group>
          <b-form-group
            id="input-group-n2Used"
            label="N2 Used:"
            label-for="input-n2Used"
          >
            <b-form-checkbox
              id="input-n2Used"
              v-model="form.n2Used"
              type="number"
              :value="1"
              :unchecked-value="0"
              placeholder="Enter N2 Used"
              :disabled="!editable"
            ></b-form-checkbox>
          </b-form-group>
          <b-form-group
            id="input-group-zoneIsolated"
            label="Zone Isolated:"
            label-for="input-zoneIsolated"
          >
            <b-form-checkbox
              id="input-zoneIsolated"
              v-model="form.zoneIsolated"
              type="number"
              :value="1"
              :unchecked-value="0"
              placeholder="Enter Zone Isolated"
              :disabled="!editable"
            ></b-form-checkbox>
          </b-form-group>
          <br />
          <b-form-group
            id="input-group-jobDescription"
            label="Job Description:"
            label-for="input-jobDescription"
            style="width: 100%"
          >
            <b-form-textarea
              id="input-jobDescription"
              v-model="form.jobDescription"
              type="text"
              placeholder="Enter Job Description"
              :disabled="!editable"
              rows="5"
            ></b-form-textarea>
          </b-form-group>

          <hr />
          <h6>CASING DETAILS</h6>
          <hr />
          <b-form-group
            id="input-group-casingSize"
            label="Casing Size:"
            label-for="input-casingSize"
          >
            <b-form-select
              id="input-casingSize"
              v-model="form.casingSize"
              type="text"
              placeholder="Enter Casing Size"
              :options="optionsComboCasingSize"
            >
            </b-form-select>
          </b-form-group>
          <b-form-group
            id="input-group-holeSize"
            label="Hole Size:"
            label-for="input-holeSize"
          >
            <b-form-input
              id="input-holeSize"
              v-model="form.holeSize"
              type="number"
              step="0.001"
              placeholder="Enter Hole Size"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-mdLand"
            label="MD Land:"
            label-for="input-mdLand"
          >
            <b-form-input
              id="input-mdLand"
              v-model="form.mdLand"
              type="number"
              step="0.001"
              placeholder="Enter MD Land"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-ratholeLength"
            label="Rathole Length:"
            label-for="input-ratholeLength"
          >
            <b-form-input
              id="input-ratholeLength"
              v-model="form.ratholeLength"
              type="number"
              step="0.001"
              placeholder="Enter Rathole Length"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-floatDepthGeneral"
            label="Float Depth General:"
            label-for="input-floatDepthGeneral"
          >
            <b-form-input
              id="input-floatDepthGeneral"
              v-model="form.floatDepthGeneral"
              type="number"
              step="0.001"
              placeholder="Enter Float Depth General"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <hr />
          <h6>DEPTH</h6>
          <hr />

          <b-form-group
            id="input-group-tvdFloat"
            label="TVD Float:"
            label-for="input-tvdFloat"
          >
            <b-form-input
              id="input-tvdFloat"
              v-model="form.tvdFloat"
              type="number"
              step="0.001"
              placeholder="Enter TVD Float"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-packerTvd"
            label="Packer TVD:"
            label-for="input-packerTvd"
          >
            <b-form-input
              id="input-packerTvd"
              v-model="form.packerTvd"
              type="number"
              step="0.001"
              placeholder="Enter Packer TVD"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <hr />
          <h5 align="center">Cementing Fluids</h5>
          <hr />
          <Fluid
            :submit-id="submitId"
            :well-id="wellId"
            :editable-ops="editable"
          />

          <hr />
          <h5 align="center">Stages</h5>
          <hr />
          <Stage
            :submit-id="submitId"
            :well-id="wellId"
            :editable-ops="editable"
          />

          <hr />
          <h5 align="center">Test</h5>
          <hr />
          <h6>CASING TEST</h6>
          <hr />
          <b-form-group
            id="input-group-testPressure"
            label="Test Pressure:"
            label-for="input-testPressure"
          >
            <b-form-input
              id="input-testPressure"
              v-model="form.testPressure"
              type="number"
              step="0.001"
              placeholder="Enter Test Pressure"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-duration"
            label="Duration:"
            label-for="input-duration"
          >
            <b-form-input
              id="input-duration"
              v-model="form.duration"
              type="number"
              step="0.001"
              placeholder="Enter Duration"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-testDate"
            label="Test Date:"
            label-for="input-testDate"
          >
            <b-form-input
              id="input-testDate"
              v-model="form.testDate"
              type="datetime-local"
              placeholder="Enter Test Date"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-packerDepth"
            label="Packer Depth:"
            label-for="input-packerDepth"
          >
            <b-form-input
              id="input-packerDepth"
              v-model="form.packerDepth"
              type="number"
              step="0.001"
              placeholder="Enter Packer Depth"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-fluidDensity"
            label="Fluid Density:"
            label-for="input-fluidDensity"
          >
            <b-form-input
              id="input-fluidDensity"
              v-model="form.fluidDensity"
              type="number"
              step="0.001"
              placeholder="Enter Fluid Density"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-floatDepth"
            label="Float Depth:"
            label-for="input-floatDepth"
          >
            <b-form-input
              id="input-floatDepth"
              v-model="form.floatDepth"
              type="number"
              step="0.001"
              placeholder="Enter Float Depth"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-cementFound"
            label="Cement Found:"
            label-for="input-cementFound"
          >
            <b-form-checkbox
              id="input-cementFound"
              v-model="form.cementFound"
              type="number"
              placeholder="Enter Cement Found"
              :disabled="!editable"
              value="1"
              unchecked-value="0"
            ></b-form-checkbox>
          </b-form-group>
          <b-form-group
            id="input-group-comments"
            label="Comments:"
            label-for="input-comments"
          >
            <b-form-input
              id="input-comments"
              v-model="form.comments"
              type="text"
              placeholder="Enter Comments"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>

          <hr />
          <h6>LOG/SURVEY EVALUATION</h6>
          <hr />
          <b-form-group
            id="input-group-cetRun"
            label="CET Run:"
            label-for="input-cetRun"
          >
            <b-form-checkbox
              id="input-cetRun"
              v-model="form.cetRun"
              type="number"
              placeholder="Enter CET Run"
              :disabled="!editable"
              value="1"
              unchecked-value="0"
            ></b-form-checkbox>
          </b-form-group>
          <b-form-group
            id="input-group-cblRun"
            label="CBL Run:"
            label-for="input-cblRun"
          >
            <b-form-checkbox
              id="input-cblRun"
              v-model="form.cblRun"
              type="number"
              placeholder="Enter CBL Run"
              :disabled="!editable"
              value="1"
              unchecked-value="0"
            ></b-form-checkbox>
          </b-form-group>
          <b-form-group
            id="input-group-cblPress"
            label="CBL Press:"
            label-for="input-cblPress"
          >
            <b-form-input
              id="input-cblPress"
              v-model="form.cblPress"
              type="number"
              step="0.001"
              placeholder="Enter CBL Press"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-timePriorToLog"
            label="Time prior to log:"
            label-for="input-timePriorToLog"
          >
            <b-form-input
              id="input-timePriorToLog"
              v-model="form.timePriorToLog"
              type="number"
              step="0.001"
              placeholder="Enter Time prior to log"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-cetQuality"
            label="CET Quality:"
            label-for="input-cetQuality"
          >
            <b-form-input
              id="input-cetQuality"
              v-model="form.cetQuality"
              type="text"
              placeholder="Enter CET Quality"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-cblQuality"
            label="CBL Quality:"
            label-for="input-cblQuality"
          >
            <b-form-input
              id="input-cblQuality"
              v-model="form.cblQuality"
              type="text"
              placeholder="Enter CBL Quality"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-bhtLogRun"
            label="BHT Log Run:"
            label-for="input-bhtLogRun"
          >
            <b-form-checkbox
              id="input-bhtLogRun"
              v-model="form.bhtLogRun"
              type="number"
              placeholder="Enter BHT Log Run"
              :disabled="!editable"
              value="1"
              unchecked-value="0"
            ></b-form-checkbox>
          </b-form-group>
          <hr />
          <h6>SHOE TEST</h6>
          <hr />
          <b-form-group
            id="input-group-shoeTestPress"
            label="Shoe test press:"
            label-for="input-shoeTestPress"
          >
            <b-form-input
              id="input-shoeTestPress"
              v-model="form.shoeTestPress"
              type="number"
              step="0.001"
              placeholder="Enter Shoe test press"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-openHoleLength"
            label="Open Hole Length:"
            label-for="input-openHoleLength"
          >
            <b-form-input
              id="input-openHoleLength"
              v-model="form.openHoleLength"
              type="number"
              step="0.001"
              placeholder="Enter Open Hole Length"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-tool"
            label="Tool:"
            label-for="input-tool"
          >
            <b-form-checkbox
              id="input-tool"
              v-model="form.tool"
              type="number"
              placeholder="Enter Tool"
              :disabled="!editable"
              value="1"
              unchecked-value="0"
            ></b-form-checkbox>
          </b-form-group>
          <b-form-group
            id="input-group-timeBeforeShoeTest"
            label="Time before shoe test:"
            label-for="input-timeBeforeShoeTest"
          >
            <b-form-input
              id="input-timeBeforeShoeTest"
              v-model="form.timeBeforeShoeTest"
              type="number"
              step="0.001"
              placeholder="Enter Time before shoe test"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <hr />
          <h6>INTERPRETATION SURVEY</h6>
          <hr />
          <b-form-group
            id="input-group-mdToc"
            label="MD TOC:"
            label-for="input-mdToc"
          >
            <b-form-input
              id="input-mdToc"
              v-model="form.mdToc"
              type="number"
              step="0.001"
              placeholder="Enter MD TOC"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-tocTvd"
            label="TOC TVD:"
            label-for="input-tocTvd"
          >
            <b-form-input
              id="input-tocTvd"
              v-model="form.tocTvd"
              type="number"
              step="0.001"
              placeholder="Enter TOC TVD"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-tocSufficient"
            label="TOC Sufficient:"
            label-for="input-tocSufficient"
          >
            <b-form-checkbox
              id="input-tocSufficient"
              v-model="form.tocSufficient"
              type="number"
              placeholder="Enter TOC Sufficient"
              :disabled="!editable"
              value="1"
              unchecked-value="0"
            ></b-form-checkbox>
          </b-form-group>
          <b-form-group
            id="input-group-remedialCementRequired"
            label="Remedial Cement Required:"
            label-for="input-remedialCementRequired"
          >
            <b-form-checkbox
              id="input-remedialCementRequired"
              v-model="form.remedialCementRequired"
              type="number"
              placeholder="Enter Remedial Cement Required"
              :disabled="!editable"
              value="1"
              unchecked-value="0"
            ></b-form-checkbox>
          </b-form-group>
          <b-form-group
            id="input-group-noSqueezes"
            label="No Squeezes:"
            label-for="input-noSqueezes"
          >
            <b-form-input
              id="input-noSqueezes"
              v-model="form.noSqueezes"
              type="number"
              step="0.001"
              placeholder="Enter No Squeezes"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-tocLocatedMethod"
            label="TOC located method:"
            label-for="input-tocLocatedMethod"
          >
            <b-form-input
              id="input-tocLocatedMethod"
              v-model="form.tocLocatedMethod"
              type="text"
              placeholder="Enter TOC located method"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-jobRating"
            label="Job Rating:"
            label-for="input-jobRating"
          >
            <b-form-input
              id="input-jobRating"
              v-model="form.jobRating"
              type="text"
              placeholder="Enter Job Rating"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-detectionIndicator"
            label="Detection Indicator:"
            label-for="input-detectionIndicator"
          >
            <b-form-input
              id="input-detectionIndicator"
              v-model="form.detectionIndicator"
              type="text"
              placeholder="Enter Detection Indicator"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-interpreter"
            label="Interpreter:"
            label-for="input-interpreter"
          >
            <b-form-input
              id="input-interpreter"
              v-model="form.interpreter"
              type="text"
              placeholder="Enter Interpreter"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-interpretation"
            label="Interpretation:"
            label-for="input-interpretation"
          >
            <b-form-input
              id="input-interpretation"
              v-model="form.interpretation"
              type="text"
              placeholder="Enter Interpretation"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <hr />
          <h6>LINER TOP TEST</h6>
          <hr />
          <b-form-group
            id="input-group-testMdTop"
            label="Test MD Top:"
            label-for="input-testMdTop"
          >
            <b-form-input
              id="input-testMdTop"
              v-model="form.testMdTop"
              type="number"
              step="0.001"
              placeholder="Enter Test MD Top"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-testSectionTvdTop"
            label="Test Section TVD Top:"
            label-for="input-testSectionTvdTop"
          >
            <b-form-input
              id="input-testSectionTvdTop"
              v-model="form.testSectionTvdTop"
              type="number"
              step="0.001"
              placeholder="Enter Test Section TVD Top"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-testMdBtm"
            label="Test MD btm:"
            label-for="input-testMdBtm"
          >
            <b-form-input
              id="input-testMdBtm"
              v-model="form.testMdBtm"
              type="number"
              step="0.001"
              placeholder="Enter Test MD btm"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-testSectionTvdBase"
            label="Test Section TVD Base:"
            label-for="input-testSectionTvdBase"
          >
            <b-form-input
              id="input-testSectionTvdBase"
              v-model="form.testSectionTvdBase"
              type="number"
              step="0.001"
              placeholder="Enter Test Section TVD Base"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-linerOverlap"
            label="Liner Overlap:"
            label-for="input-linerOverlap"
          >
            <b-form-input
              id="input-linerOverlap"
              v-model="form.linerOverlap"
              type="number"
              step="0.001"
              placeholder="Enter Liner Overlap"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-timeBeforeTest"
            label="Time Before Test:"
            label-for="input-timeBeforeTest"
          >
            <b-form-input
              id="input-timeBeforeTest"
              v-model="form.timeBeforeTest"
              type="number"
              step="0.001"
              placeholder="Enter Time Before Test"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-negativeTestTool"
            label="Negative Test Tool:"
            label-for="input-negativeTestTool"
          >
            <b-form-checkbox
              id="input-negativeTestTool"
              v-model="form.negativeTestTool"
              type="number"
              placeholder="Enter Negative Test Tool"
              :disabled="!editable"
              value="1"
              unchecked-value="0"
            ></b-form-checkbox>
          </b-form-group>
          <b-form-group
            id="input-group-negativeTestEmw"
            label="Negative Test EMW:"
            label-for="input-negativeTestEmw"
          >
            <b-form-input
              id="input-negativeTestEmw"
              v-model="form.negativeTestEmw"
              type="number"
              step="0.001"
              placeholder="Enter Negative Test EMW"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-positiveTestTool"
            label="Positive Test Tool:"
            label-for="input-positiveTestTool"
          >
            <b-form-checkbox
              id="input-positiveTestTool"
              v-model="form.positiveTestTool"
              type="number"
              placeholder="Enter Positive Test Tool"
              :disabled="!editable"
              value="1"
              unchecked-value="0"
            ></b-form-checkbox>
          </b-form-group>
          <b-form-group
            id="input-group-positiveTestEmw"
            label="Positive Test EMW:"
            label-for="input-positiveTestEmw"
          >
            <b-form-input
              id="input-positiveTestEmw"
              v-model="form.positiveTestEmw"
              type="number"
              step="0.001"
              placeholder="Enter Positive Test EMW"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-cmtFoundOnTool"
            label="Cmt Found on Tool:"
            label-for="input-cmtFoundOnTool"
          >
            <b-form-checkbox
              id="input-cmtFoundOnTool"
              v-model="form.cmtFoundOnTool"
              type="number"
              placeholder="Enter Cmt Found on Tool"
              :disabled="!editable"
              value="1"
              unchecked-value="0"
            ></b-form-checkbox>
          </b-form-group>
          <hr />
          <h6>SHOETRACK CEMENT TEST</h6>
          <hr />
          <b-form-group
            id="input-group-shoetrackTopMd"
            label="Shoetrack Top MD:"
            label-for="input-shoetrackTopMd"
          >
            <b-form-input
              id="input-shoetrackTopMd"
              v-model="form.shoetrackTopMd"
              type="number"
              step="0.001"
              placeholder="Enter Shoetrack Top MD"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-shoetrackTopTvd"
            label="Shoetrack Top TVD:"
            label-for="input-shoetrackTopTvd"
          >
            <b-form-input
              id="input-shoetrackTopTvd"
              v-model="form.shoetrackTopTvd"
              type="number"
              step="0.001"
              placeholder="Enter Shoetrack Top TVD"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-shoetrackDrillDateTime"
            label="Shoetrack Drill Date Time:"
            label-for="input-shoetrackDrillDateTime"
          >
            <b-form-input
              id="input-shoetrackDrillDateTime"
              v-model="form.shoetrackDrillDateTime"
              type="datetime-local"
              placeholder="Enter Shoetrack Drill Date Time"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-shoetrackDrillMd"
            label="Shoetrack Drill MD:"
            label-for="input-shoetrackDrillMd"
          >
            <b-form-input
              id="input-shoetrackDrillMd"
              v-model="form.shoetrackDrillMd"
              type="number"
              step="0.001"
              placeholder="Enter Shoetrack Drill MD"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-shoetrackDrillTvd"
            label="Shoetrack Drill TVD:"
            label-for="input-shoetrackDrillTvd"
          >
            <b-form-input
              id="input-shoetrackDrillTvd"
              v-model="form.shoetrackDrillTvd"
              type="number"
              step="0.001"
              placeholder="Enter Shoetrack Drill TVD"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>

          <hr />
          <h5 align="center">Intermediate Circulations</h5>
          <hr />
          <IntCirculation
            :submit-id="submitId"
            :well-id="wellId"
            :editable-ops="editable"
          />
          <hr />
          <h5 align="center">Isolated Intervals</h5>
          <hr />
          <IsoInterval
            :submit-id="submitId"
            :well-id="wellId"
            :editable-ops="editable"
          />
        </div>
        <hr />
      </div>

      <!-- <p>{{ selectedRow }}</p> -->
    </div>
  </div>

  <!-- MODALS -->
</template>

<script>
import Vue from 'vue'
import VueFormGenerator from 'vue-form-generator'
import 'vue-form-generator/dist/vfg.css'
import { formMethods, formComputed } from '@state/helpers'
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
import Fluid from '@components/form/drilling-activity/cement-fluid'
import Stage from '@components/form/drilling-activity/cement-stage.vue'
import IntCirculation from '@components/form/drilling-activity/cement-int-circulation.vue'
import IsoInterval from '@components/form/drilling-activity/cement-iso-interval'
import notify from "devextreme/ui/notify"

Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)

Vue.use(VueFormGenerator)

export default {
  components: { Fluid, Stage, IntCirculation, IsoInterval },
  props: {
    // eslint-disable-next-line vue/require-default-prop
    submitId: {type: Number, default: undefined},
    editable: Boolean,
    wellId: {type: Number, default: undefined},
  },
  data() {
    return {
      form: [],
      show: true,
      hasData: false,
      editableOps: this.editable,
      optionsComboHoleSize: [],
      optionsComboCasingSize: [],
      optionsComboJobType: [],
    }
  },
  computed: {
    ...formComputed,
  },
  watch: {
    submitId: function (value) {
      this.init()
    },
    editable: function (val) {
      this.editableOps = val
    },
    wellId: function (value) {
      // this.init()
    },
  },
  created: function () {
    this.init()
  },
  methods: {
    ...formMethods,
    init() {
      this.loadAllCombo()
      this.form = []
      this.loadData()
    },
    loadData() {
      this.getActivityCementFix({
        params: { submitId: this.submitId },
      }).then((resp) => {
        if (resp.data.data.length > 0) {
          this.hasData = true
          this.form = resp.data.data[0]
        }
        console.log('this.hasData', this.hasData)
      })
    },
    loadAllCombo() {
      this.loadComboHoleSize()
      this.loadComboCasingSize()
      this.loadComboJobType()
    },
    loadComboJobType() {
      this.getComboListJobType({ params: {} }).then((resp) => {
        let _arrData = resp.data.data
        this.optionsComboJobType = []
        for (var i = 0; i < _arrData.length; i++) {
          let _temp = {
            value: _arrData[i].comboId,
            text: _arrData[i].comboValue,
          }
          this.optionsComboJobType.push(_temp)
        }
      })
    },
    convertNomSize(nom) {
      if (!isNaN(nom)) return nom
      let sizeStrings = nom.split(" ")
      let sizeValue = parseFloat(sizeStrings[0])
      if (sizeStrings.length > 1) {
        let element = sizeStrings[1].split("/")
        let elementsValue = parseFloat(element[0]) / parseFloat(element[1])
        sizeValue += elementsValue
      }
      return sizeValue
    },
    loadComboHoleSize() {
      this.getComboListWorkstringSize({ params: {} }).then((resp) => {
        let _arrData = resp.data.data
        _arrData.sort((x,y)=>this.convertNomSize(x.comboValue)-this.convertNomSize(y.comboValue))
        this.optionsComboHoleSize = []
        for (var i = 0; i < _arrData.length; i++) {
          let _temp = {
            value: _arrData[i].comboId,
            text: _arrData[i].comboValue,
          }
          this.optionsComboHoleSize.push(_temp)
        }
      })
    },
    loadComboCasingSize() {
      this.getComboListCasingSize({ params: {} }).then((resp) => {
        let _arrData = resp.data.data
        this.optionsComboCasingSize = []
        for (var i = 0; i < _arrData.length; i++) {
          let _temp = {
            value: _arrData[i].comboId,
            text: _arrData[i].comboValue,
          }
          this.optionsComboCasingSize.push(_temp)
        }
      })
    },
    makeToast(msg) {
      this.$bvToast.toast(msg, {
        title: 'Notification',
        autoHideDelay: 5000,
        appendToast: false,
      })
    },
    onSubmit(evt) {
      evt.preventDefault()

      if (this.hasData) {
        // if intId is exist that means data has already at server
        // time to update
        const data = { ...this.form }
        this.updateActivityCementFix({ params: data }).then((resp) => {
          notify({ message: 'Data has been recorded.', width: 300 }, 'success', 5000)
        })
      } else {
        // time to insert
        const data = { ...this.form, submitId: this.submitId }
        this.addActivityCementFix({ params: data }).then((resp) => {
          this.hasData = true
          notify({ message: 'Data has been recorded.', width: 300 }, 'success', 5000)
        })
      }
    },
    onReset(evt) {
      evt.preventDefault()
      this.form = []
      this.show = false
      this.$nextTick(() => {
        this.show = true
      })
    },
  },
}
</script>